import axios from 'axios'
import { notifySuccess } from 'utils/common'

class SN {
  constructor (data) {
    this.id = data.id // number
    this.sn = data.snHex // string 16进制sn号
    this.pn = data.pnHex // string 16进制pn号
    this.state = data.snStatus // number sn号状态
    this.simNo = data.simNo // SIM卡号
    this.productId = data.productId // 产品ID
    this.systemId = data.systemId // number 所属系统id
    this.systemName = data.systemName // string 所属系统名称
    this.updatedAt = data.updatedAt || data.createdAt || '' // date 最后更新时间
  }
}

class Log {
  constructor (data) {
    this.id = data.id // number
    this.sn = data.sn ? String(data.sn) : '' // string 16进制sn号
    this.operation = data.operation // number sn号状态
    this.nickname = data.nickname // 操作用户昵称 string
    this.createdAt = data.createdAt || '' // date 创建时间
  }
}

/**
 * 获取sn列表
 * @param  {Number} snStatus 查询参数，sn状态
 * @param  {Number} systemId 查询参数，系统id
 * @param  {String} username 查询参数，用户名
 * @param  {*Number} pageNo 当前页
 * @param  {*Number} pageSize 每页条数
 * @return {Array}
 */
export const getList = async (options = {}) => {
  let params = Object.assign({}, options)
  Object.keys(params).forEach(key => {
    if (!params[key]) {
      delete params[key]
    }
  })
  const { data: { recordCount, records } } = await axios.get('v1/device-sns', { params })
  const list = records.map(item => new SN(item))
  return { list, total: recordCount }
}

/**
 * 获取sn对应的操作日志
 * @param {*String} sn 16进制sn号
 */
export const getLogList = async (sn) => {
  const { data } = await axios.get('v1/sn-operation-logs', {
    params: { sn }
  })
  return data.map(item => new Log(item))
}

/**
 * 批量生成sn号
 * @param  {*Object} data
 * @return {Object}
 */
export const create = async (data) => {
  await axios.post('v1/device-sns/gen', data)
  notifySuccess('生成成功。正在下载……')

  setTimeout(() => {
    download()
  }, 2000)
}

/**
 * 下载sn号二维码
 */
export const download = async () => {
  const { data: { url } } = await axios.get('v1/device-sns/download-url')
  window.open(url)
}
